export const reduxKey = '@@ONE_TIME_PASSWORD';
